function clearTicketsDirective() {
    'ngInject';

    const link = function ($scope, elem, attrs, ctrls) {
        const init = function () {
            if ($scope.bb.current_item.event) {
                $scope.bl_spaces_left = getSpacesLeft($scope.bb.current_item.event);
                // Delete the tickets from the current item
                // delete $scope.bb.current_item.tickets;
                // Remove all items from the basket so we don't event up silently making loads
                // of bookings when we go back and forth
                // $scope.emptyBasket();         
            }
        };

        /***
         * @ngdoc method
         * @name getNumBooked
         * @methodOf BB.Models:Event
         * @description
         * Get the number booked
         *
         * @returns {object} The returned number booked
         */
        const getNumBooked = function (event) {
            return event.spaces_blocked + event.spaces_booked + event.spaces_reserved + event.spaces_held;
        }


        /***
        * @ngdoc method
        * @name getSpacesLeft
        * @methodOf BB.Models:Event
        * @description
        * Get the number of spaces left (possibly limited by a specific ticket pool)
        *
        * @returns {object} The returned spaces left
        */
        const getSpacesLeft = function (event) {
            const x = event.num_spaces - getNumBooked(event);
            if (x < 0) {
                return 0;
            }
            return x;
        }

        init();
    };

    return {
        restrict: 'AE',
        replace: true,
        scope: true,
        link
    };
}

angular
    .module('westBerkshireEvents.clearTickets')
    .directive('wbClearTickets', clearTicketsDirective);


// WEBPACK FOOTER //
// src/public/javascripts/clear-tickets/clear_tickets.directive.js